export default __webpack_public_path__ + "static/media/img-18.10b6e7e2.jpg";